var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoomerangTemplate01 = function SvgBoomerangTemplate01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boomerang_template-01_svg2__a",
    x1: 19.72,
    x2: 138.55,
    y1: 141.96,
    y2: 10.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomerang_template-01_svg2__a",
    id: "boomerang_template-01_svg2__b",
    x1: 19.71,
    x2: 138.54,
    y1: 141.96,
    y2: 10.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomerang_template-01_svg2__a",
    id: "boomerang_template-01_svg2__c",
    x1: 54.6,
    x2: 173.43,
    y1: 173.56,
    y2: 42.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomerang_template-01_svg2__a",
    id: "boomerang_template-01_svg2__d",
    x1: 47.16,
    x2: 165.98,
    y1: 166.82,
    y2: 35.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomerang_template-01_svg2__a",
    id: "boomerang_template-01_svg2__e",
    x1: 63.74,
    x2: 182.57,
    y1: 181.83,
    y2: 50.64
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M99.99 83.33c16.57 0 30-13.43 30-30s-13.43-30-30-30-30 13.43-30 30c.02 16.56 13.44 29.98 30 30m0-53.33c12.89 0 23.33 10.45 23.33 23.33s-10.45 23.33-23.33 23.33-23.33-10.45-23.33-23.33C76.67 40.45 87.11 30.01 99.99 30",
    style: {
      fill: "url(#boomerang_template-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.99 69.99c9.2 0 16.67-7.46 16.67-16.67s-7.46-16.67-16.67-16.67-16.67 7.46-16.67 16.67c.01 9.2 7.47 16.66 16.67 16.67m0-26.66c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10",
    style: {
      fill: "url(#boomerang_template-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.98 126.66c0-2.84-1.82-5.36-4.51-6.27l-33.72-12.06 33.73-12.06a6.616 6.616 0 0 0 4.17-8.37 6.6 6.6 0 0 0-4.17-4.17L143.15 65c.09-.33.2-.67.28-1l6.16-1.88a5.02 5.02 0 0 0 3.56-4.36c.13-1.46.2-2.93.2-4.42s-.06-2.96-.2-4.42a5.02 5.02 0 0 0-3.56-4.36l-6.17-1.88a43.8 43.8 0 0 0-5.18-12.49l3.02-5.67c.98-1.81.76-4.03-.56-5.61-.94-1.12-1.94-2.21-3-3.26a61 61 0 0 0-3.26-3 5.04 5.04 0 0 0-5.6-.56l-5.69 3.03a44.2 44.2 0 0 0-12.47-5.19l-1.88-6.16a5.06 5.06 0 0 0-4.37-3.56c-2.94-.26-5.9-.26-8.84 0-2.04.19-3.77 1.6-4.36 3.56l-1.88 6.15c-4.4 1.08-8.61 2.83-12.49 5.19l-5.69-3.02a5.05 5.05 0 0 0-5.62.56c-1.12.93-2.21 1.93-3.26 3s-2.05 2.14-3 3.26a5.04 5.04 0 0 0-.57 5.61l3.03 5.69a44.5 44.5 0 0 0-5.17 12.47l-6.16 1.88a5.02 5.02 0 0 0-3.56 4.36c-.13 1.46-.2 2.93-.2 4.42s.06 2.96.2 4.41a5.02 5.02 0 0 0 3.56 4.37L56.57 64c.08.33.19.67.28 1L4.51 83.72a6.616 6.616 0 0 0-4.17 8.37c.66 1.97 2.2 3.51 4.17 4.17l33.73 12.06-33.73 12.06a6.62 6.62 0 0 0-4.17 8.38c.66 1.97 2.2 3.51 4.17 4.17l29.06 10.39-29.06 10.4a6.62 6.62 0 0 0-4.17 8.38c.66 1.97 2.2 3.51 4.17 4.17l93.08 33.3c1.55.56 3.24.56 4.78 0l93.09-33.3a6.62 6.62 0 0 0 4.17-8.38 6.6 6.6 0 0 0-4.17-4.17l-29.06-10.4 29.06-10.39a6.64 6.64 0 0 0 4.51-6.27ZM53.42 56.06c-.06-.91-.08-1.82-.08-2.73s.03-1.82.08-2.72l6.97-2.13a3.33 3.33 0 0 0 2.3-2.54 37.7 37.7 0 0 1 5.71-13.75c.68-1.02.75-2.34.17-3.42l-3.43-6.43c.6-.67 1.22-1.33 1.87-1.98s1.31-1.27 2-1.87l6.45 3.43c1.09.58 2.4.51 3.42-.18 4.15-2.8 8.82-4.75 13.73-5.73 1.2-.24 2.18-1.12 2.54-2.29l2.13-6.97c1.81-.11 3.63-.11 5.45 0l2.13 6.97a3.35 3.35 0 0 0 2.54 2.29c4.92.97 9.59 2.91 13.74 5.71 1.02.69 2.34.75 3.42.18l6.44-3.42c.67.6 1.33 1.22 1.98 1.87s1.27 1.31 1.87 1.98l-3.42 6.45c-.58 1.09-.51 2.4.17 3.43 2.8 4.15 4.75 8.83 5.72 13.75a3.33 3.33 0 0 0 2.3 2.54l6.97 2.13c.06.9.08 1.81.08 2.72s-.03 1.82-.08 2.72l-6.97 2.13a3.33 3.33 0 0 0-2.3 2.54 37.7 37.7 0 0 1-5.71 13.75 3.34 3.34 0 0 0-.17 3.42l3.41 6.43c-.6.67-1.22 1.33-1.87 2s-1.31 1.27-1.98 1.87l-6.45-3.43c-1.09-.58-2.4-.51-3.42.18-4.15 2.8-8.83 4.74-13.74 5.72-1.2.24-2.18 1.12-2.54 2.29l-2.13 6.97c-1.81.11-3.63.11-5.45 0l-2.13-6.97a3.35 3.35 0 0 0-2.54-2.29 37.7 37.7 0 0 1-13.75-5.71 3.34 3.34 0 0 0-3.42-.17L69 88.21a57 57 0 0 1-2-1.87c-.67-.65-1.27-1.31-1.87-2l3.43-6.45c.58-1.09.51-2.4-.17-3.43a37.7 37.7 0 0 1-5.71-13.75 3.33 3.33 0 0 0-2.3-2.54zM6.76 89.99l52.32-18.72c.78 1.8 1.68 3.54 2.69 5.21l-3.02 5.67c-.98 1.81-.76 4.03.56 5.61.94 1.12 1.94 2.21 3 3.26s2.15 2.05 3.26 3a5.04 5.04 0 0 0 5.6.56l5.69-3.03c3.87 2.36 8.07 4.11 12.47 5.2l1.88 6.16a5.045 5.045 0 0 0 4.36 3.56c1.46.13 2.93.2 4.42.2s2.96-.06 4.42-.2c2.05-.19 3.77-1.6 4.36-3.56l1.88-6.15c4.4-1.08 8.61-2.83 12.49-5.19l5.69 3.02c1.81.98 4.04.76 5.62-.56 1.12-.93 2.21-1.93 3.26-3s2.05-2.14 3-3.26c1.32-1.58 1.54-3.8.57-5.61l-3.03-5.69c1.01-1.67 1.9-3.41 2.68-5.2L193.24 90l-93.37 33.29zm186.47 69.99-93.37 33.3-93.1-33.3 36.71-13.13 54.14 19.36c1.55.56 3.24.56 4.78 0l54.14-19.36 36.71 13.13Zm-93.36-.04h-.01l-93.1-33.28 41.38-14.79 49.47 17.7c1.55.56 3.24.56 4.78 0l49.48-17.7 41.38 14.79-93.37 33.29Z",
    style: {
      fill: "url(#boomerang_template-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16 143.51h.01l-37.28-13.33c-1.75-.57-3.63.39-4.2 2.14-.54 1.68.31 3.48 1.95 4.13l37.28 13.33c.36.13.74.2 1.12.2 1.84 0 3.33-1.5 3.33-3.34 0-1.4-.88-2.66-2.21-3.13",
    style: {
      fill: "url(#boomerang_template-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16 176.84h.01l-37.28-13.33c-1.75-.57-3.63.39-4.2 2.14-.54 1.68.31 3.48 1.95 4.13l37.28 13.33c.36.13.74.2 1.12.2 1.84 0 3.33-1.5 3.33-3.34 0-1.4-.88-2.66-2.21-3.13",
    style: {
      fill: "url(#boomerang_template-01_svg2__e)"
    }
  }));
};
export default SvgBoomerangTemplate01;